import PropTypes from "prop-types"
import classnames from "classnames"
import InfoTooltip from "components/info-tooltip"
import { colorWithOpacity } from "helpers/colors"

function Row({ data, column: { color, noData, isUnmodeled }, index, selector, tooltipContentsFn }) {
  let loading = !data[index] && !noData && !isUnmodeled
  let value = !loading && !noData && !isUnmodeled && selector && selector(data[index])
  const tooltipContents = !loading && !noData && !isUnmodeled && typeof tooltipContentsFn === "function" && tooltipContentsFn(data[index])
  if (value === "Loading...") {
    loading = true
    value = ""
  }

  const style = loading
    ? { background: `linear-gradient(90deg, ${colorWithOpacity(color, 0.1)}, ${colorWithOpacity(color, 0.3)})` }
    : { backgroundColor: colorWithOpacity(color, 0.1) }

  return <div className={classnames("value", { loading })} style={style}>
    {tooltipContents && <InfoTooltip title={tooltipContents}>{value}</InfoTooltip>}
    {!tooltipContents && value}
  </div>
}

Row.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  selector: PropTypes.func,
  tooltipContentsFn: PropTypes.func,
  data: PropTypes.array.isRequired,
}

export default Row
